// @ts-nocheck
(function () {
  if (window.__occasionFinderLoaded) return;
  window.__occasionFinderLoaded = true;

  const initOccasionFinder = () => {
  let overlay = document.getElementById('occasion-finder-overlay');
  let modal1 = document.getElementById('occasion-modal-1');
  let modal2 = document.getElementById('occasion-modal-2');
  let closeBtns = document.querySelectorAll('.occasion-close-btn');
  let occasionCards = document.querySelectorAll('.occasion-card');
  let ctaBtn = document.getElementById('occasion-cta-btn');
  let productsGrid = document.getElementById('occasion-products-grid');
  let occasionTitle = document.getElementById('occasion-modal-2-title');

  const ensureOccasionModal = () => {
    overlay = document.getElementById('occasion-finder-overlay');
    modal2 = document.getElementById('occasion-modal-2');
    if (!overlay) {
      const overlayHtml = `
        <div id="occasion-finder-overlay" class="occasion-finder-overlay" aria-hidden="true" role="presentation">
          <div id="occasion-modal-2" class="occasion-finder-modal" role="dialog" aria-modal="true" aria-labelledby="occasion-modal-2-title" style="position: relative; max-width: 900px; max-height: 90vh; overflow-y: auto;">
            <button type="button" class="occasion-close-btn" aria-label="Close modal">&times;</button>
            <div class="occasion-finder-header">
              <h2 id="occasion-modal-2-title">Recommended Styles</h2>
            </div>
            <div id="occasion-products-grid" class="occasion-products-grid"></div>
            <div id="occasion-load-more-container" class="occasion-load-more-container"></div>
          </div>
        </div>
      `;
      document.body.insertAdjacentHTML('beforeend', overlayHtml);
      overlay = document.getElementById('occasion-finder-overlay');
      modal2 = document.getElementById('occasion-modal-2');

      const closeBtn = overlay?.querySelector('.occasion-close-btn');
      if (closeBtn) closeBtn.addEventListener('click', closeModals);
      overlay?.addEventListener('click', (e) => {
        if (e.target === overlay) closeModals();
      });
    }
    productsGrid = document.getElementById('occasion-products-grid');
    occasionTitle = document.getElementById('occasion-modal-2-title');
    return { overlay, modal2 };
  };

  if (modal1) {
    modal1.setAttribute('aria-modal', 'true');
    modal1.setAttribute('role', 'dialog');
  }
  if (modal2) {
    modal2.setAttribute('aria-modal', 'true');
    modal2.setAttribute('role', 'dialog');
  }

  /** @type {{ name: string, tag: string } | null} */
  let selectedOccasion = null;

  // Set up IntersectionObserver
  const setupObserver = () => {
    if (!overlay || !modal1) return;
    // Look for the recently viewed section from the third party app, or fallback to the footer
    const targetElement = document.querySelector('[id*="recently-viewed"], [id*="17815038230ad42774"]') || document.querySelector('footer');
    
    if (targetElement) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          // Trigger when the element is at least 50% visible, or if fallback, just when intersecting
          if (entry.isIntersecting) {
            showQuizModal();
            observer.disconnect();
          }
        });
      }, {
        threshold: 0.1 // Trigger when 10% visible
      });
      observer.observe(targetElement);
    } else {
      // Fallback: trigger after scrolling 50% of the page
      const handleScroll = () => {
        const scrolled = window.scrollY;
        const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
        if (scrolled > maxScroll * 0.5) {
          showQuizModal();
          window.removeEventListener('scroll', handleScroll);
        }
      };
      window.addEventListener('scroll', handleScroll, { passive: true });
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      closeModals();
      return;
    }
    if (e.key === 'Tab') {
      const isModal1Active = modal1 && modal1.classList.contains('is-active');
      const isModal2Active = modal2 && modal2.classList.contains('is-active');
      const activeModal = isModal1Active ? modal1 : (isModal2Active ? modal2 : null);
      if (!activeModal) return;
      
      const focusableElements = activeModal.querySelectorAll('a[href], button:not([disabled]), textarea, input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (focusableElements.length === 0) return;
      const firstFocusableElement = focusableElements[0];
      const lastFocusableElement = focusableElements[focusableElements.length - 1];
      
      if (e.shiftKey) { // Shift + Tab
        if (document.activeElement === firstFocusableElement || !activeModal.contains(document.activeElement)) {
          lastFocusableElement.focus();
          e.preventDefault();
        }
      } else { // Tab
        if (document.activeElement === lastFocusableElement || !activeModal.contains(document.activeElement)) {
          firstFocusableElement.focus();
          e.preventDefault();
        }
      }
    }
  };

  const showQuizModal = () => {
    if (!overlay || !modal1) return;
    overlay.classList.add('is-active');
    modal1.classList.add('is-active');
    document.body.classList.add('occasion-modal-open');
    localStorage.setItem('occasionQuizShown', 'true');
    document.addEventListener('keydown', handleKeyDown);
    
    // Focus first element
    setTimeout(() => {
      const firstFocusable = modal1 ? modal1.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])') : null;
      if (firstFocusable) firstFocusable.focus();
    }, 50);
  };

  const closeModals = () => {
    if (overlay) overlay.classList.remove('is-active');
    if (modal1) modal1.classList.remove('is-active');
    if (modal2) modal2.classList.remove('is-active');
    document.body.classList.remove('occasion-modal-open');
    document.removeEventListener('keydown', handleKeyDown);
    // Wait for animation before removing inactivity class
    if (modal1) {
      setTimeout(() => {
        modal1.classList.remove('is-inactive');
      }, 400);
    }
  };

  closeBtns.forEach(btn => btn.addEventListener('click', closeModals));
  if (overlay) {
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closeModals();
    });
  }

  // Handle Card Selection
  occasionCards.forEach(card => {
    card.addEventListener('click', () => {
      // Remove selected from all
      occasionCards.forEach(c => {
        c.classList.remove('is-selected');
        const title = c.querySelector('.occasion-card-title');
        if (title) title.classList.remove('text-white');
      });
      // Add to clicked
      card.classList.add('is-selected');
      const activeTitle = card.querySelector('.occasion-card-title');
      if (activeTitle) activeTitle.classList.add('text-white');
      
      selectedOccasion = {
        name: card.dataset.name,
        tag: card.dataset.tag
      };

      // Update CTA
      if (ctaBtn) {
        ctaBtn.textContent = `See ${selectedOccasion.name} Products \u2192`; // ->
        ctaBtn.classList.add('is-active');
      }
    });
  });

  // Handle CTA Click
  if (ctaBtn) {
    ctaBtn.addEventListener('click', () => {
      if (!selectedOccasion) return;

      // Transition to Modal 2
      modal1.classList.remove('is-active');
      modal1.classList.add('is-inactive');
      
      setTimeout(() => {
        modal2.classList.remove('is-inactive');
        modal2.classList.add('is-active');
        fetchAndRenderProducts(selectedOccasion);
      }, 300); // Wait for modal 1 to scale down
    });
  }

  let currentOccasion = null;
  let currentPage = 1;
  let isFetchingMore = false;
  let activeFetchController = null;

  const getLoadMoreContainer = () => {
    let container = document.getElementById('occasion-load-more-container');
    if (!container && modal2) {
      container = document.createElement('div');
      container.id = 'occasion-load-more-container';
      container.className = 'occasion-load-more-container';
      modal2.appendChild(container);
    }
    return container;
  };

  const updateSeeMoreButton = (meta) => {
    const container = getLoadMoreContainer();
    if (!container) return;

    if (!meta || meta.hasNext !== 'true') {
      const totalItems = parseInt(meta?.totalItems, 10) || 0;
      const totalPages = parseInt(meta?.totalPages, 10) || 1;

      if (totalPages > 1) {
        container.innerHTML = `<p class="occasion-all-loaded-text">Showing all ${totalItems} styles</p>`;
      } else {
        container.innerHTML = '';
      }
      return;
    }

    const remaining = parseInt(meta.remaining, 10);
    const label = remaining > 0 ? `See More Styles (${remaining} remaining)` : 'See More Styles';

    container.innerHTML = `
      <button type="button" class="occasion-see-more-btn" id="occasion-see-more-btn" aria-label="${label}">
        ${label}
      </button>
    `;

    const btn = document.getElementById('occasion-see-more-btn');
    if (btn) {
      btn.addEventListener('click', handleSeeMoreClick);
    }
  };

  const handleSeeMoreClick = async () => {
    if (isFetchingMore || !currentOccasion) return;
    const btn = document.getElementById('occasion-see-more-btn');
    if (btn) {
      btn.disabled = true;
      btn.innerHTML = `<span class="occasion-see-more-spinner" aria-hidden="true"></span> Loading styles...`;
    }
    isFetchingMore = true;
    currentPage += 1;

    const requestedOccasionTag = currentOccasion.tag;
    if (activeFetchController) {
      activeFetchController.abort();
    }
    activeFetchController = new AbortController();
    const signal = activeFetchController.signal;

    try {
      const tagQuery = `(tag:${encodeURIComponent(currentOccasion.tag)} OR tag:${encodeURIComponent(currentOccasion.tag.toLowerCase())})`;
      const searchUrl = (typeof Theme !== 'undefined' && Theme.routes?.search_url) || window.routes?.search_url || '/search';
      const response = await fetch(`${searchUrl}?q=${tagQuery}&type=product&section_id=occasion-finder-results&page=${currentPage}`, { signal });
      if (!response.ok) throw new Error('Network response was not ok');
      const htmlText = await response.text();

      // Guard against stale response if occasion switched while request was in-flight
      if (!currentOccasion || currentOccasion.tag !== requestedOccasionTag) {
        return;
      }

      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, 'text/html');
      const sectionContent = doc.querySelector('.shopify-section, [id^="shopify-section"]') || doc.body;

      // Extract new cards and append to grid without re-rendering existing items
      const newCards = sectionContent.querySelectorAll('.occasion-product-card');
      if (newCards.length > 0 && productsGrid) {
        const fragment = document.createDocumentFragment();
        newCards.forEach((card) => fragment.appendChild(card));
        productsGrid.appendChild(fragment);
      }

      const metaEl = sectionContent.querySelector('.occasion-pagination-meta');
      const meta = metaEl ? {
        currentPage: metaEl.getAttribute('data-current-page'),        totalPages: metaEl.getAttribute('data-total-pages'),
        totalItems: metaEl.getAttribute('data-total-items'),
        remaining: metaEl.getAttribute('data-remaining'),
        hasNext: metaEl.getAttribute('data-has-next')
      } : null;

      updateSeeMoreButton(meta);
    } catch (error) {
      if (error.name === 'AbortError') return;
      console.error('Error fetching more occasion products:', error);
      currentPage -= 1;
      if (btn) {
        btn.disabled = false;
        btn.textContent = 'Error loading styles. Tap to retry';
      }
    } finally {
      isFetchingMore = false;
    }
  };

  const fetchAndRenderProducts = async (occasion) => {
    if (!occasion) return;
    currentOccasion = occasion;
    currentPage = 1;
    isFetchingMore = false;

    if (activeFetchController) {
      activeFetchController.abort();
    }
    activeFetchController = new AbortController();
    const signal = activeFetchController.signal;
    const requestedOccasionTag = occasion.tag;

    const templateStr = window.theme?.locales?.recommended_occasion_styles || `Recommended {{ occasion }} Styles`;
    if (occasionTitle) {
      occasionTitle.textContent = templateStr.replace('{{ occasion }}', occasion.name);
    }
    if (!productsGrid) return;

    const container = getLoadMoreContainer();
    if (container) {
      container.innerHTML = '';
    }

    productsGrid.innerHTML = `
      <div class="occasion-loading">
        <div class="occasion-loading-spinner"></div>
        Fetching styles...
      </div>
    `;

    try {
      // Use Shopify Section Rendering API
      // Searching tag with case-insensitive fallback (tag:Party OR tag:party)
      const tagQuery = `(tag:${encodeURIComponent(occasion.tag)} OR tag:${encodeURIComponent(occasion.tag.toLowerCase())})`;
      const searchUrl = (typeof Theme !== 'undefined' && Theme.routes?.search_url) || window.routes?.search_url || '/search';
      const response = await fetch(`${searchUrl}?q=${tagQuery}&type=product&section_id=occasion-finder-results&page=1`, { signal });
      if (!response.ok) throw new Error('Network response was not ok');
      const htmlText = await response.text();
      
      // Guard against stale response if occasion switched while request was in-flight
      if (!currentOccasion || currentOccasion.tag !== requestedOccasionTag) {
        return;
      }

      // Parse the returned HTML (Shopify returns the HTML inside a div with the section ID)
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, 'text/html');
      
      // Extract the content from the rendered section
      const sectionContent = doc.querySelector('.shopify-section, [id^="shopify-section"]') || doc.body;
      const cards = sectionContent.querySelectorAll('.occasion-product-card');
      const metaEl = sectionContent.querySelector('.occasion-pagination-meta');
      
      if (cards.length > 0) {
        const fragment = document.createDocumentFragment();
        cards.forEach((card) => fragment.appendChild(card));
        productsGrid.innerHTML = '';
        productsGrid.appendChild(fragment);
      } else {
        const noProductsWrap = document.createElement('div');
        noProductsWrap.style.cssText = 'text-align: center; width: 100%; padding: 30px 20px;';
        const p = document.createElement('p');
        p.textContent = 'No products found. Please check back later!';
        noProductsWrap.appendChild(p);
        if (occasion.link) {
          const shopLink = document.createElement('a');
          shopLink.href = occasion.link;
          shopLink.textContent = `Shop all ${occasion.name}`;
          shopLink.className = 'occasion-see-more-btn';
          shopLink.style.cssText = 'display: inline-block; margin-top: 14px; text-decoration: none;';
          noProductsWrap.appendChild(shopLink);
        }
        productsGrid.innerHTML = '';
        productsGrid.appendChild(noProductsWrap);
      }

      const meta = metaEl ? {
        currentPage: metaEl.getAttribute('data-current-page'),        totalPages: metaEl.getAttribute('data-total-pages'),
        totalItems: metaEl.getAttribute('data-total-items'),
        remaining: metaEl.getAttribute('data-remaining'),
        hasNext: metaEl.getAttribute('data-has-next')
      } : null;

      updateSeeMoreButton(meta);
      
    } catch (error) {
      if (error.name === 'AbortError') return;
      console.error('Error fetching occasion products:', error);
      if (productsGrid) {
        productsGrid.innerHTML = `<p style="text-align:center; width:100%; color:red;">There was an error loading the styles. Please refresh the page.</p>`;
      }
      if (container) {
        container.innerHTML = '';
      }
    }
  };

  let isOpeningModal = false;
  // Expose global function to directly open the occasion modal
  window.openOccasionFinder = (occasion) => {
    if (isOpeningModal) return;
    isOpeningModal = true;
    setTimeout(() => { isOpeningModal = false; }, 400);

    let occasionObj = null;
    if (typeof occasion === 'string') {
      const tag = occasion.trim();
      const name = occasion.charAt(0).toUpperCase() + occasion.slice(1);
      occasionObj = { name, tag };
    } else if (occasion && (occasion.tag || occasion.name)) {
      occasionObj = {
        name: occasion.name || occasion.tag,
        tag: occasion.tag || occasion.name,
        link: occasion.link || ''
      };
    }
    if (!occasionObj) return;

    localStorage.setItem('occasionQuizShown', 'true');

    if (modal1) {
      modal1.classList.remove('is-active');
      modal1.classList.add('is-inactive');
    }

    const { overlay: activeOverlay, modal2: activeModal2 } = ensureOccasionModal();
    if (activeOverlay && activeModal2) {
      activeOverlay.classList.add('is-active');
      activeOverlay.setAttribute('aria-hidden', 'false');
      activeModal2.classList.remove('is-inactive');
      activeModal2.classList.add('is-active');
      document.body.classList.add('occasion-modal-open');
      document.addEventListener('keydown', handleKeyDown);
      fetchAndRenderProducts(occasionObj);
    }
  };

  // Only auto-trigger quiz on scroll if not already shown AND if quiz modal markup exists in the DOM
  if (localStorage.getItem('occasionQuizShown') !== 'true' && overlay && modal1) {
    setupObserver();
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initOccasionFinder);
} else {
  initOccasionFinder();
}
})();
